<template>
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page">
    <div id="kt_login" class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
        <div class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
          <!--begin::Content-->
          <!-- <div class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper"> -->
          <!--begin::Head-->

          <!--end::Head-->

          <!--begin::Body-->
          <div class="kt-login__body">
            <!--begin::Signin-->
            <div class="kt-login__form">
              <div class="d-flex flex-column-fluid">
                <!--begin::Container-->
                <div class=" container ">
                  <div class="card card-custom">
                    <div class="card-body p-20 kt-margin-t-20">
                      <!--begin::Wizard-->
                      <div id="kt_wizard_v1" class="wizard wizard-1" data-wizard-state="first" data-wizard-clickable="false">
                        <!--begin::Wizard Body-->
                        <div class="row justify-content-center">
                          <div v-if="isReset && !isSuccess" class="col-xl-9">
                            <div class="main-icon-without-slide pd-lv4 placeholder kt-align-center" data-type="img" data-large="https://image.flaticon.com/icons/svg/481/481195.svg">
                              <img width="64" height="64" src="https://image.flaticon.com/icons/svg/481/481195.svg" class="loaded">
                            </div>
                            <div class="col-xl-12">
                              <!--begin::Wizard Form-->
                              <div class="kt-margin-10">
                                <!-- <h1>Welcome to ELI</h1> -->
                                <div class="kt-margin-b-30 kt-margin-t-20 kt-align-center">
                                  <h5>Reset your password</h5>
                                </div>

                                <form ref="form">
                                  <b-form-group :state="isPassword1Valid" label="New password" label-for="reset-password-input" :invalid-feedback="isPassword1InvalidFeedback">
                                    <b-form-input
                                      id="reset-password-input"
                                      v-model="password1"
                                      type="password"
                                      @input="trackCustomEvent({ event: 'input', action: 'type', target: 'input_box_reset_password' })"
                                    />
                                  </b-form-group>

                                  <b-form-group :state="isPassword2Valid" label="Confirm New password" label-for="reset-confirm-password-input" :invalid-feedback="isPassword2InvalidFeedback">
                                    <b-form-input
                                      id="reset-confirm-password-input"
                                      v-model="password2"
                                      type="password"
                                      @input="trackCustomEvent({ event: 'input', action: 'type', target: 'input_box_reset_password' })"
                                    />
                                  </b-form-group>

                                  <div class="kt-login__actions">
                                    <button
                                      id="kt_login_signin_submit"
                                      class="btn btn-brand kt-block-center"
                                      :class="{ 'kt-spinner kt-spinner--md kt-spinner--light': isLoading }"
                                      :disabled="!validInput"
                                      @click="trackCustomEvent({ action: 'clicked', target: 'reset_password' }); resetPassword($event)"
                                    >
                                      Reset password
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div v-if="isSuccess && !isReset" class="col-xl-12">
                            <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10 kt-align-center">
                              <div>
                                <svg
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  version="1.1"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 512 512"
                                  style="enable-background:new 0 0 512 512;"
                                  xml:space="preserve"
                                  width="80px"
                                  height="80px"
                                  class=""
                                >
                                  <g>
                                    <g>
                                      <g>
                                        <path d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.331,26.629,74.98,74.98C26.628,123.332,0,187.62,0,256    s26.628,132.667,74.98,181.019C123.332,485.371,187.619,512,256,512c68.38,0,132.667-26.629,181.019-74.981    C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30    s226,101.383,226,226S380.617,482,256,482z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#00AF80" />
                                      </g>
                                    </g><g>
                                      <g>
                                        <path d="M378.305,173.859c-5.857-5.856-15.355-5.856-21.212,0.001L224.634,306.319l-69.727-69.727    c-5.857-5.857-15.355-5.857-21.213,0c-5.858,5.857-5.858,15.355,0,21.213l80.333,80.333c2.929,2.929,6.768,4.393,10.606,4.393    c3.838,0,7.678-1.465,10.606-4.393l143.066-143.066C384.163,189.215,384.163,179.717,378.305,173.859z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#00AF80" />
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                                <div class="col-xl-12">
                                  <!--begin::Wizard Form-->
                                  <div class="kt-margin-30">
                                    <!-- <h1>Welcome to ELI</h1> -->
                                    <h3>Success!</h3>
                                    <div class="kt-margin-t-20">
                                      Your password has been successfully changed.
                                    </div>
                                    Please login to ELI with your new password.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="kt-align-center kt-margin-b-30">
                              <router-link :to="`/login`">
                                <button
                                  type="button"
                                  class="btn btn-brand btn-sm kt-block-center sign-up-msg"
                                  @click="trackCustomEvent({ action: 'clicked', target: 'login_reset_password', linkTo: 'login' })"
                                >
                                  <span class="kt-font-bold">Continue to Login</span>
                                </button>
                              </router-link>
                            </div>
                          </div>
                          <div v-if="!isSuccess && !isReset" class="col-xl-12">
                            <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10 kt-align-center">
                              <div>
                                <svg
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  version="1.1"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 512 512"
                                  style="enable-background:new 0 0 512 512;"
                                  xml:space="preserve"
                                  width="80px"
                                  height="80px"
                                ><g><g transform="translate(1 1)">
                                  <g>
                                    <g>
                                      <path d="M436.016,73.984c-99.979-99.979-262.075-99.979-362.033,0.002c-99.978,99.978-99.978,262.073,0.004,362.031     c99.954,99.978,262.05,99.978,362.029-0.002C535.995,336.059,535.995,173.964,436.016,73.984z M405.848,405.844     c-83.318,83.318-218.396,83.318-301.691,0.004c-83.318-83.299-83.318-218.377-0.002-301.693     c83.297-83.317,218.375-83.317,301.691,0S489.162,322.549,405.848,405.844z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#C12020" />
                                      <path d="M254.996,84.338c-11.782,0-21.333,9.551-21.333,21.333v213.333c0,11.782,9.551,21.333,21.333,21.333     c11.782,0,21.333-9.551,21.333-21.333V105.671C276.329,93.889,266.778,84.338,254.996,84.338z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#C12020" />
                                      <path d="M254.996,383.004c-11.776,0-21.333,9.557-21.333,21.333s9.557,21.333,21.333,21.333c11.776,0,21.333-9.557,21.333-21.333     S266.772,383.004,254.996,383.004z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#C12020" />
                                    </g>
                                  </g>
                                </g></g> </svg>
                                <div class="col-xl-12">
                                  <!--begin::Wizard Form-->
                                  <div class="kt-margin-30">
                                    <!-- <h1>Welcome to ELI</h1> -->
                                    <h3>Something went wrong.</h3>
                                    <div class="kt-margin-t-20">
                                      The reset link is not valid.
                                    </div>
                                    It has already been used to reset or it has expired.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="kt-align-center kt-margin-b-30">
                              <router-link :to="`/login`">
                                <button
                                  type="button"
                                  class="btn btn-brand btn-sm kt-block-center sign-up-msg"
                                  @click="trackCustomEvent({ action: 'clicked', target: 'login_reset_password', linkTo: 'login' })"
                                >
                                  <span class="kt-font-bold">Continue to Login</span>
                                </button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                        <!--end::Wizard Body-->
                      </div>
                    </div>
                    <!--end::Wizard-->
                  </div>
                </div>
                <!--end::Container-->
              </div>
            </div>

            <!--end::Signin-->
          </div>

          <!--end::Body-->
          <!-- </div> -->

        <!--end::Content-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInput, BFormGroup } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import util from '../utils'

export default {
  components: {
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput
  },
  data () {
    return {
      password1: '',
      password2: '',
      isPassword1Changed: false,
      isPassword2Changed: false,
      isLoading: false,
      isChanged: false,
      isReset: true,
      isSuccess: false
    }
  },
  computed: {
    email () {
      return this.$route.query.email ? this.$route.query.email : 'your email'
    },
    isPassword1Valid () {
      return this.password1.length >= 6
    },
    isPassword2Valid () {
      return this.password1.length >= 6 && this.password1 === this.password2
    },
    isPassword1InvalidFeedback () {
      if (!this.isPassword1Valid && !this.isPassword1Changed) {
        return ''
      } else {
        return 'Passwords must contain at least 6 characters'
      }
    },
    isPassword2InvalidFeedback () {
      if (!this.isPassword2Valid && !this.isPassword2Changed) {
        return ''
      } else if (!this.isPassword2Valid && this.password2.length !== 0) {
        return 'The password does not match'
      } else {
        return 'Passwords must contain at least 6 characters'
      }
    },
    validInput () {
      return this.isPassword1Valid && this.isPassword2Valid
    }
  },
  watch: {
    password1 () {
      this.isPassword1Changed = true
    },
    password2 () {
      this.isPassword2Changed = true
    }
  },
  methods: {
    ...mapActions({
      resetPasswordRequest: 'user/resetPassword',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async resetPassword (e) {
      e.preventDefault()
      this.isLoading = true
      const resetPasswordResult = await this.resetPasswordRequest({
        newPassword: this.password2,
        token: this.$route.query.token,
        source: this.$route.query.source
      })
      const result = resetPasswordResult ? resetPasswordResult.message : undefined
      if (result === 'success') {
        this.isReset = false
        this.isSuccess = true
      } else {
        this.isReset = false
        this.isSuccess = false
      }
      await util.sleep(5000)
      this.$router.replace({ path: '/login' })
    }
  }
}
</script>
